module.exports = __webpack_public_path__ + "img/20200709_160331.7af4f6a9.jpg";